module.exports = __webpack_public_path__ + "static/img/1035_small.a5628b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1035_small.png
// module id = 7qsz
// module chunks = 1